import React, { useMemo, useState } from "react";
import { FaStar } from "react-icons/fa";
import HeaderImg from "../../../assets/findAgent/headerImg.webp"
import GeneralEnquiry from "../GeneralEnquiry/GeneralEnquiry";
import { Link } from "react-router-dom";
import {
  formatAgencyReviewAverage,
  getAgencyReviewStats,
} from "../../../utils/agencyReviewStats";

const AgencyNewContactCard = ({
  AgencyData,
  reviewlength: reviewlengthProp,
  totalaverage: totalaverageProp,
}) => {
  const [Next, setNext] = useState(true);
  const [whichActive, setWhichActive] = useState("Selling a property");
  const ActiveTab = "bg-[#E5002A] text-white";

  const { average: computedAverage, totalCount: computedReviewCount } = useMemo(
    () =>
      getAgencyReviewStats(AgencyData?.agents, AgencyData?.agencyReviews),
    [AgencyData],
  );

  const reviewCount =
    reviewlengthProp ?? computedReviewCount;
  const averageRating = formatAgencyReviewAverage(
    totalaverageProp ?? computedAverage,
  );
  return (
    <div
      className="bg-white rounded-2xl overflow-hidden"
    >
      {/* Header */}
      <div
        className={`px-6 py-4 flex justify-center items-center md:rounded-t-2xl ${AgencyData?.primary_color ? "" : "bg-black"}`}
        style={
          AgencyData?.primary_color
            ? { backgroundColor: AgencyData.primary_color }
            : undefined
        }
      >
        <Link to={`/agency-profile/${AgencyData?._id}`}>
          <img
            src={AgencyData?.agencyLargeLogo || HeaderImg}
            alt="Agency Logo"
            className="h-10 object-contain"
          />
        </Link>
      </div>

      {/* Body */}
      <div className="p-6">

        {/* Title */}
        <h3 className="text-2xl font-bold text-[#000929]">
          Contact {AgencyData?.principal_name}
        </h3>

        {/* Rating */}
        <div className="flex items-center mt-2 gap-1 text-sm text-[#6B7280]">
          <div className="flex items-center gap-1">
            <FaStar className="text-[#C2C823] text-sm" />
            <span className="font-medium text-[#000929]">
              {averageRating || 0.0}
            </span>
          </div>
          <span>
            ( {reviewCount} {reviewCount === 1 ? "review" : "reviews"} )
          </span>
        </div>

        <div className="bg-[#EAEAEA] h-[1.5px] w-full my-6"></div>

        {/* Section Title */}
        <h3 className="text-xl font-medium text-[#000929] mb-4">
          What's your enquiry about?
        </h3>

        {Next ? (
          <>
            {/* Enquiry Buttons */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                "Selling a property",
                "Property Management",
                "An advertised property",
                "General enquiry",
              ].map((item) => {
                const isActive = whichActive === item;

                return (
                  <button
                    key={item}
                    onClick={() => setWhichActive(item)}
                    className={`
          relative flex items-center justify-between
          px-6 py-2 rounded-full text-sm md:text-base
          transition-all duration-200
          border-[1.5px]
          ${isActive
                        ? "border-[#097FE6] bg-[#097FE61A] text-[#000929]"
                        : "border-[#E5E7EB]  text-[#3D3B40] hover:border-[#2F6FED]"
                      }
        `}
                  >
                    {item}

                    {/* Check Circle */}
                    {isActive && (
                      <div className="w-5 h-5 rounded-full bg-[#2F6FED] flex items-center justify-center">
                        <svg
                          className="w-3 h-3 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Next Button */}
            <button
              onClick={() => setNext(false)}
              className={`w-full mt-6 py-3 rounded-full text-base font-medium transition-all duration-200
            ${whichActive
                  ? "bg-[#097FE6] text-white hover:opacity-90"
                  : "bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed"
                }`}
            >
              Next
            </button>
          </>
        ) : (
          <div className="mt-4">
            <GeneralEnquiry
              setNext={setNext}
              whichActive={whichActive}
              data={AgencyData}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AgencyNewContactCard;
